import React, { useState, useEffect } from 'react';
import { resetPassword } from '../services/api';

function ResetPassword() {
  const [token, setToken] = useState('');
  const [nuevaPassword, setNuevaPassword] = useState('');
  const [confirmarPassword, setConfirmarPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [exito, setExito] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get('token');
    if (t) setToken(t);
    else setError('Enlace inválido. Solicita uno nuevo.');
  }, []);

  const handleSubmit = async () => {
    if (!nuevaPassword || !confirmarPassword) { setError('Completa todos los campos'); return; }
    if (nuevaPassword.length < 6) { setError('La contraseña debe tener al menos 6 caracteres'); return; }
    if (nuevaPassword !== confirmarPassword) { setError('Las contraseñas no coinciden'); return; }

    setLoading(true); setError('');
    try {
      await resetPassword({ token, nuevaPassword });
      setExito(true);
    } catch (err) {
      setError(err.response?.data?.message || 'El enlace es inválido o ha expirado.');
    } finally { setLoading(false); }
  };

  if (exito) {
    return (
      <div style={{ minHeight: '100vh', background: '#0d2461', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
        <div style={{ background: 'white', borderRadius: 16, padding: '48px 40px', width: '100%', maxWidth: 420, boxShadow: '0 25px 50px rgba(0,0,0,0.3)', textAlign: 'center' }}>
          <div style={{ width: 64, height: 64, background: '#dcfce7', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: 28 }}>✅</div>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: '#0d2461', margin: 0 }}>Contraseña Actualizada</h1>
          <p style={{ fontSize: 14, color: '#64748b', marginTop: 12, lineHeight: 1.5 }}>
            Tu contraseña se cambió correctamente. Ya puedes iniciar sesión con tu nueva contraseña.
          </p>
          <a href="/" style={{ display: 'block', width: '100%', padding: 13, background: '#0d2461', color: 'white', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', marginTop: 20, textDecoration: 'none', boxSizing: 'border-box' }}>
            Ir al Login
          </a>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#0d2461', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: 'white', borderRadius: 16, padding: '48px 40px', width: '100%', maxWidth: 420, boxShadow: '0 25px 50px rgba(0,0,0,0.3)' }}>

        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ width: 64, height: 64, background: '#0d2461', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: 28 }}>🔒</div>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: '#0d2461', margin: 0 }}>Nueva Contraseña</h1>
          <p style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>Crea una contraseña segura</p>
        </div>

        {error && (
          <div style={{ background: '#fee2e2', color: '#cc0000', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16, border: '1px solid #fca5a5' }}>
            ⚠️ {error}
          </div>
        )}

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#334155', marginBottom: 6 }}>Nueva Contraseña</label>
          <input
            type="password" value={nuevaPassword}
            onChange={e => setNuevaPassword(e.target.value)}
            style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 14, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' }}
            placeholder="••••••••"
          />
        </div>

        <div style={{ marginBottom: 24 }}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#334155', marginBottom: 6 }}>Confirmar Contraseña</label>
          <input
            type="password" value={confirmarPassword}
            onChange={e => setConfirmarPassword(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleSubmit()}
            style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 14, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' }}
            placeholder="••••••••"
          />
        </div>

        <button onClick={handleSubmit} disabled={loading || !token}
          style={{ width: '100%', padding: 13, background: (loading || !token) ? '#94a3b8' : '#0d2461', color: 'white', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: (loading || !token) ? 'not-allowed' : 'pointer', fontFamily: 'inherit' }}>
          {loading ? 'Actualizando...' : 'Restablecer Contraseña'}
        </button>
      </div>
    </div>
  );
}

export default ResetPassword;